import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable.js"; // Assuming DataTable component is reusable
import { fetchDataFromAPI, deleteData, saveData } from "../components/api.js"; // Assuming these API functions exist
import subscriptionStatus from "../components/SubscriptionStatus.js"; // Assuming subscriptionStatus logic is needed

const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.5
  }
  return {}; // Return empty object for non-range types
};

const Career = () => {
  const [careers, setCareers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  const isSubscribed = subscriptionStatus(); // This will check the subscription status (if needed)

  useEffect(() => {
    fetchData();
  }, [filters, sortField, sortOrder, currentPage]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token"); // Retrieve token for authorization
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters, // Apply filters to the query
      };
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      const filterParams = new URLSearchParams(filterParamsObj).toString();

      // Fetch careers data
      const { data: careers, pagination } = await fetchDataFromAPI(
        `/api/career`,
        filterParams,
        token
      );

      setCareers(careers || []);
      setTotalPages(pagination?.totalPages || 1);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching careers:", err.message);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/career/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting career:", err);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchData();
  };

  const handleSort = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  const handleEdit = async (id, updatedData) => {
    try {
      await saveData(`/api/career/${id}`, updatedData); // Edit the career data
      fetchData();
    } catch (err) {
      console.error("Error editing career:", err);
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchData();
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  const handleAddRow = async () => {
    try {
      const newRow = {
        title: "New career", // Title field
        code: "", // Code field
        description: "", // Description
        location: "", // Location
        tag: "", // Tag
        department: ".", // Department
        type: "onsite", // Type (valid options)
        active: "active", // Active status ("active" or "inactive")
      };

      const result = await saveData("/api/career", newRow, "POST");
      console.log("Career added:", result); // Debug: Log result to ensure it was successful
      fetchData(); // Refresh the career list after adding
    } catch (err) {
      console.error("Error adding row:", err); // Log any errors
    }
  };

  const columns = [
    { header: "Title", accessor: "title" },
    { header: "Code", accessor: "code" },
    { header: "Description", accessor: "description" },
    { header: "Location", accessor: "location" },
    { header: "Tag", accessor: "tag" },
    { header: "Department", accessor: "department" },
    {
      header: "Type",
      accessor: "type",
      type: "dropdown",
      options: [
        { value: "remote", label: "Remote" },
        { value: "onsite", label: "On site" },
        { value: "hybrid", label: "Hybrid" },
      ],
    },
    {
      header: "Active",
      accessor: "active",
      type: "dropdown",
      options: [
        { value: "active", label: "active" },
        { value: "inactive", label: "inactive" },
      ],
    },
    {
      header: "Created At",
      accessor: "created_at",
      type: "showOnly",
    },
  ];

  return (
    <div
    // style={{
    //   backgroundColor: "#F4F6F9", // Dashboard background
    //   minHeight: "100vh",
    //   padding: "20px",
    //   position: "relative", // Make the container relative to position the button
    // }}
    >
      {" "}
      <DataTable
        title="Career Listings"
        columns={columns}
        data={careers}
        currentPage={currentPage}
        totalPages={totalPages}
        onSort={handleSort}
        sortField={sortField}
        sortOrder={sortOrder}
        setData={setCareers}
        onPageChange={handlePageChange}
        filters={filters}
        onAddRow={handleAddRow}
        onFilterChange={handleFilterChange}
        actions={[
          {
            label: "Edit",
            onClick: (row) => {
              const updatedData = { ...row, title: "Updated Title" }; // Update the title with new data
              handleEdit(row.id, updatedData); // Trigger the edit
            },
          },
          {
            label: "Delete",
            onClick: (row) => handleDelete(row.id), // Trigger the delete
          },
        ]}
        apiEndpoint="/api/career"
        itemsPerPage={10}
        getRangeInputProps={getRangeInputProps}
        fetchData={fetchData}
      />
    </div>
  );
};

export default Career;
